import {useFetchBanks} from '@rocket-ui/lk-api';
import {FC, useEffect, useMemo} from 'react';
import {useAtomValue} from 'jotai';
import {isAuthorizedAtom} from 'features/auth/model/authAtom';
import {
	bankFromApi,
	extractCardDigits,
	formatCardDisplay,
	PAYMENT_CARD_COMMISSION_HINT,
	PAYMENT_CARD_COMMISSION_VALUE,
	SelectedBank,
} from '../../model';
import {PaymentReviewStep} from './PaymentReviewStep';

const CARD_BIN_LENGTH = 6;

type Props = {
	card: string;
	isPrimary: boolean;
	showPrimaryToggle?: boolean;
	onPrimaryChange: (value: boolean) => void;
	onBankResolved: (bank: SelectedBank | null) => void;
};

export const PaymentCardReviewStep: FC<Props> = ({
	card,
	isPrimary,
	showPrimaryToggle = true,
	onPrimaryChange,
	onBankResolved,
}) => {
	const isAuthorized = useAtomValue(isAuthorizedAtom);
	const cardDigits = extractCardDigits(card);
	const bin = cardDigits.slice(0, CARD_BIN_LENGTH);
	const binReady = bin.length >= CARD_BIN_LENGTH;

	const {data: banks = []} = useFetchBanks(binReady ? {bin} : undefined, {enabled: isAuthorized && binReady});

	const bank = useMemo(() => (banks[0] ? bankFromApi(banks[0]) : null), [banks]);

	useEffect(() => {
		onBankResolved(bank);
	}, [bank?.id, bank, onBankResolved]);

	return (
		<PaymentReviewStep
			fields={[{label: 'Номер карты', value: formatCardDisplay(cardDigits)}]}
			bank={bank}
			commission={{
				value: PAYMENT_CARD_COMMISSION_VALUE,
				hint: PAYMENT_CARD_COMMISSION_HINT,
			}}
			isPrimary={isPrimary}
			showPrimaryToggle={showPrimaryToggle}
			onPrimaryChange={onPrimaryChange}
		/>
	);
};
